const setIsLoading = (loading, dispatch) => {
  dispatch({
    type: "setIsLoading",
    isLoading: loading
  });
};

const setErrors = (errors, dispatch) => {
  dispatch({
    type: "setErrors",
    errors: errors
  });
};

const setIsLoggedIn = (isLoggedIn, dispatch) => {
  dispatch({
    type: "setIsLoggedIn",
    isLoggedIn: isLoggedIn
  });
};

const setSysCfg = (sysCfg, dispatch) => {
  dispatch({
    type: "setSysCfg",
    sysCfg: sysCfg
  });
};

const setService = (service, dispatch) => {
  dispatch({
    type: "setService",
    service: service
  });
};

const setUser = (user, dispatch) => {
  dispatch({
    type: "setUser",
    user: user
  });
}

export { setIsLoading, setErrors, setIsLoggedIn, setSysCfg, setService, setUser };
